import React, { useEffect } from 'react'

import Myprofile from '../myprofile/Myprofile';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getAccountUserDetailsThunk } from '../../../../Website/redux/AccountUserSlice';
import ViewUserCamp from '../../Components/addNewUserComp/ViewUserCamp';


const ViewAccountUser = () => {
    const { id } = useParams()
    const dispatch = useDispatch()
    const { loading } = useSelector((state) => state.accountUser)
    useEffect(() => {
        dispatch(getAccountUserDetailsThunk(id))
    }, [])


    if (loading) {
        return <div>please wait..</div>
    }

    return (
        <>
            <Myprofile>
                <ViewUserCamp/>
            </Myprofile>

        </>
    )
}

export default ViewAccountUser